import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  BackButton,
  AlternativeContact,
  Button,
  Content,
  Input,
  InputContainer,
  Label,
  Textarea,
  Title,
} from "./RequestRemovalPage.styles";

import { toast } from "sonner";
import MainContainer from "../../components/MainContainer";
import { navigateToTop } from "../../utils/utils";

import { ReactComponent as ChevronLeft } from "../../assets/icons/chevronLeft.svg";

import { selectSubmitRequestLoading } from "../../store/slices/user/slice";
import { submitRequest } from "../../store/slices/user/asyncThunk";
import { selectLoggedIn } from "../../store/slices/auth/slice";
import { setSignUpModalOpen } from "../../store/slices/common/slice";

const RequestRemovalPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loading = useSelector(selectSubmitRequestLoading);
  const [form, setForm] = useState({ name: "", details: "" });
  const loggedIn = useSelector(selectLoggedIn);

  const updateField = (field) => (e) =>
    setForm((prev) => ({ ...prev, [field]: e.target.value }));

  const handleSubmit = async () => {
    if (!loggedIn) {
      dispatch(setSignUpModalOpen(true));
      return;
    }

    if (!form.name.trim() || !form.details.trim()) {
      toast.error("Please fill in all fields");
      return;
    }

    try {
      await dispatch(
        submitRequest({
          type: "content-removal",
          title: form.name,
          description: form.details,
        }),
      ).unwrap();

      toast.success("Removal request submitted successfully");
      navigateToTop(navigate, "/");
    } catch (err) {
      toast.error(err?.message || "Something went wrong");
    }
  };

  return (
    <MainContainer>
      <Content>
        <BackButton onClick={() => navigateToTop(navigate, "/")}>
          <ChevronLeft />
          Back
        </BackButton>

        <Title>Request removal of content</Title>

        <InputContainer>
          <Label>Name</Label>
          <Input
            value={form.name}
            onChange={updateField("name")}
            placeholder="Enter content URL or title"
          />
        </InputContainer>

        <InputContainer>
          <Label>Details</Label>
          <Textarea
            value={form.details}
            onChange={updateField("details")}
            placeholder="Describe the violation and what do you think should be removed"
          />
        </InputContainer>

        <Button onClick={handleSubmit} disabled={loading}>
          {loading && (
            <l-line-spinner size="16" stroke="1.25" speed="1.5" color="black" />
          )}
          Submit Request
        </Button>

        <AlternativeContact>
          Alternatively, email us at{" "}
          <a href="mailto:complaints@playbun.com">complaints@playbun.com</a>
        </AlternativeContact>
      </Content>
    </MainContainer>
  );
};

export default RequestRemovalPage;
